__turbopack_context__.v({
  "component": "style-module-scss-module__vfNXBa__component",
  "contact": "style-module-scss-module__vfNXBa__contact",
  "contact-button": "style-module-scss-module__vfNXBa__contact-button",
  "deal-icon": "style-module-scss-module__vfNXBa__deal-icon",
  "disclaimer": "style-module-scss-module__vfNXBa__disclaimer",
  "estimation-disclaimer-text": "style-module-scss-module__vfNXBa__estimation-disclaimer-text",
  "grey-icon": "style-module-scss-module__vfNXBa__grey-icon",
  "stat-row": "style-module-scss-module__vfNXBa__stat-row",
  "superscript": "style-module-scss-module__vfNXBa__superscript",
  "zoocasa-link": "style-module-scss-module__vfNXBa__zoocasa-link",
});
